"use strict";
// tslint:disable
/**
 * Router service API
 * Router API is used for managing endpoints and routing interactions. The core resources of this api are:   * <strong>Endpoints</strong> Endpoints traditionally would be refered to as agents in a CC context.   * <strong>Skill Group</strong> Skill Groups which are the primary grouping / method of how interactions are routed, sometimes called queues.   * <strong>Interactions</strong> Interactions can be voice calls, chats or any routable item.   * <strong>Channel</strong> The term channel is used to refer to an interaction type.   * <strong>Reasons</strong>  Reasons are the 'WHYs' which provide a way to categorize the type. E.g. Reasons for 'Away' type can be 'Lunch', 'Break', 'Emergency' etc. Reasons for 'Away' type are mainly applied to endpoints. Reasons for 'Disposition' type can be 'Follow up', 'Refund', 'Complete' etc. Reasons for 'Disposition' type are mainly applied to interactions   * <strong>Templates</strong> Templates can be created for different purpose based on the 'Type' specified e.g. It can be created for quick replies when handling interaction or it can be created for custom display extension.   * <strong>Notes</strong> It provides a way to add contextual data/important details for an interaction as messages in that stream. Once note is created response contains a note reference link that points to actual message stream. The same reference link will then be on interaction resource. Use that reference link to perfom notes related operations e.g. fetch/create messages in note stream.  All of the routing logic is through a skill assignment, endpoints have skills. Skill groups have skills.. and interactions are matched.
 *
 * OpenAPI spec version: 2018-03-03
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * RouterService
 * @class
 */
class RouterService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-router',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Router' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Creates a channel with the given parameters.
    * @summary Create a channel on an endpoint. i.e. give this endpoint this capability to handle these types of interactions
    * @param {string} endpointId endpointId
    * @param {ChannelPostRequest} body Channel POST request object
    * @throws {RequiredError}
    */
    createChannel(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling createChannel.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createChannel.');
        }
        const path = `/endpoints/{endpointId}/channels`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete/remove a channel from an endpoint. Items already assigned to an endpoint will continue to be handled only new items will not be routed.
    * @summary Delete/remove a channel from an endpoint
    * @param {string} endpointId endpointId
    * @param {string} channelId ChannelId
    * @throws {RequiredError}
    */
    deleteChannel(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling deleteChannel.');
        }
        // verify required parameter 'channelId' is not null or undefined
        if (params.channelId === null || params.channelId === undefined) {
            throw new utils_1.RequiredError('channelId', 'Required parameter channelId was null or undefined when calling deleteChannel.');
        }
        const path = `/endpoints/{endpointId}/channels/{channelId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'channelId'}}`, String(params.channelId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all channels for this principal.
    * @summary Get channels for this endpointId
    * @param {string} endpointId endpointId
    * @param {string} channelId ChannelId
    * @throws {RequiredError}
    */
    getChannel(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getChannel.');
        }
        // verify required parameter 'channelId' is not null or undefined
        if (params.channelId === null || params.channelId === undefined) {
            throw new utils_1.RequiredError('channelId', 'Required parameter channelId was null or undefined when calling getChannel.');
        }
        const path = `/endpoints/{endpointId}/channels/{channelId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'channelId'}}`, String(params.channelId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all channels
    * @summary Get channels. Channels are bascially interaction types i.e voice, chat etc.
    * @param {string} endpointId endpointId
    * @throws {RequiredError}
    */
    getChannels(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getChannels.');
        }
        const path = `/endpoints/{endpointId}/channels`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a channel with the given parameters.
    * @summary Update a channel on an endpoint
    * @param {string} endpointId endpointId
    * @param {string} channelId ChannelId
    * @param {ChannelPutRequest} body Channel POST request object
    * @throws {RequiredError}
    */
    updateChannel(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateChannel.');
        }
        // verify required parameter 'channelId' is not null or undefined
        if (params.channelId === null || params.channelId === undefined) {
            throw new utils_1.RequiredError('channelId', 'Required parameter channelId was null or undefined when calling updateChannel.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateChannel.');
        }
        const path = `/endpoints/{endpointId}/channels/{channelId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'channelId'}}`, String(params.channelId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a endpoint with the given parameters.
    * @summary Create an endpoint target for routing. If being used in a user context use the userId of the user.
    * @param {EndpointPostRequest} body Endpoint POST request object
    * @throws {RequiredError}
    */
    createEndpoint(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createEndpoint.');
        }
        const path = `/endpoints`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the endpoint for the provided ID.
    * @summary Delete an endpoint by its id
    * @param {string} endpointId endpointId
    * @throws {RequiredError}
    */
    deleteEndpoint(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling deleteEndpoint.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the endpoint for the provided ID.  Returns top level aggregate and principal state.
    * @summary Get an endpoint by its id
    * @param {string} endpointId endpointId
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getEndpoint(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpoint.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets current state of this endpoint
    * @summary Get current state of an endpoint
    * @param {string} endpointId endpointId
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getEndpointState(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointState.');
        }
        const path = `/endpoints/{endpointId}/state`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets endpoints.  Can be filtered with `$skip` and `$top` or items query parameters.  Returns the top level aggregate and principal presence.
    * @summary Get endpoints. Endpoints are targets for routing items. Endpoints typically have a 1-1 relation to a userId in the system however they can be used independantly.
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Expand] expands an attribute
    * @param {string} [$Count] count the number of total records and return that along with the paged results. count property may differ from result set
    * @throws {RequiredError}
    */
    getEndpoints(params) {
        const path = `/endpoints`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        if (params.$Count !== undefined) {
            query['$count'] = params.$Count;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the endpoint for the provided ID.
    * @summary Update an endpoint by its id
    * @param {string} endpointId endpointId
    * @param {EndpointPutRequest} body Endpoint PUT request object
    * @throws {RequiredError}
    */
    updateEndpoint(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateEndpoint.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateEndpoint.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the endpoint presence for the provided ID.
    * @summary Update an endpoints presence by its id
    * @param {string} endpointId endpointId
    * @param {EndpointPostPresenceChangeRequest} body Endpoint POST presence request object
    * @throws {RequiredError}
    */
    updateEndpointPresence(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateEndpointPresence.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateEndpointPresence.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Adds a skill with the given parameters.
    * @summary Add a skill to an endpoint
    * @param {string} endpointId endpointId
    * @param {EndpointSkillPostRequest} body Skill POST request object
    * @throws {RequiredError}
    */
    createEndpointSkill(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling createEndpointSkill.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createEndpointSkill.');
        }
        const path = `/endpoints/{endpointId}/skills`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a skill for this endpoint
    * @summary Delete a skill from an endpoint
    * @param {string} endpointId endpointId
    * @param {string} skillId SkillId
    * @throws {RequiredError}
    */
    deleteEndpointSkill(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling deleteEndpointSkill.');
        }
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling deleteEndpointSkill.');
        }
        const path = `/endpoints/{endpointId}/skills/{skillId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets a skill for the given id.
    * @summary Get an endpoint skill for the id
    * @param {string} endpointId endpointId
    * @param {string} skillId SkillId
    * @throws {RequiredError}
    */
    getEndpointSkill(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointSkill.');
        }
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling getEndpointSkill.');
        }
        const path = `/endpoints/{endpointId}/skills/{skillId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all skills for endpoint
    * @summary Get endpoint skills which are used to pair up interactions in skill groups
    * @param {string} endpointId endpointId
    * @throws {RequiredError}
    */
    getEndpointSkills(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointSkills.');
        }
        const path = `/endpoints/{endpointId}/skills`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a skill with the given parameters.
    * @summary Update an endpoint skill
    * @param {string} endpointId endpointId
    * @param {string} skillId SkillId
    * @param {EndpointSkillPutRequest} body Skill update request object
    * @throws {RequiredError}
    */
    updateEndpointSkill(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateEndpointSkill.');
        }
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling updateEndpointSkill.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateEndpointSkill.');
        }
        const path = `/endpoints/{endpointId}/skills/{skillId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates notes conversation stream for an interaction. It provides a way to add contextual data/important details for an interaction as messages in that stream.  * Response contains a note reference link that points to actual message stream.  * Use this reference link to perfom notes related operations e.g. fetch/create messages in note stream
    * @summary Creates notes conversation stream for an interaction
    * @param {string} interactionId InteractionId
    * @throws {RequiredError}
    */
    createNote(params) {
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling createNote.');
        }
        const path = `/interactions/{interactionId}/notes`
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a participant with the provided ID for note stream.
    * @summary Creates a participant with the provided ID for note stream
    * @param {string} interactionId InteractionId
    * @param {string} noteId notes conversation Id
    * @param {NoteParticipantPostRequest} body Note participant POST request object
    * @throws {RequiredError}
    */
    createNoteParticipant(params) {
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling createNoteParticipant.');
        }
        // verify required parameter 'noteId' is not null or undefined
        if (params.noteId === null || params.noteId === undefined) {
            throw new utils_1.RequiredError('noteId', 'Required parameter noteId was null or undefined when calling createNoteParticipant.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createNoteParticipant.');
        }
        const path = `/interactions/{interactionId}/notes/{noteId}/participants`
            .replace(`{${'interactionId'}}`, String(params.interactionId))
            .replace(`{${'noteId'}}`, String(params.noteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a interaction with the given parameters.
    * @summary Create a interaction or Queue an interaction
    * @param {string} skillGroupId SkillGroupId
    * @param {InteractionPostRequest} body Interaction POST request object
    * @throws {RequiredError}
    */
    createSkillGroupInteraction(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling createSkillGroupInteraction.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSkillGroupInteraction.');
        }
        const path = `/skillgroups/{skillGroupId}/interactions`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete an interaction in the system by its ID. Favor usage of the actual routing item routes for endpoints or skill groups and use the appropriate command
    * @summary Delete an interaction in the system by its ID. Note this should not be used in regular code paths the individual SkillsGroup/interaction or Endpoint/interactions route should be used instead
    * @param {string} interactionId InteractionId
    * @throws {RequiredError}
    */
    deleteInteractionById(params) {
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling deleteInteractionById.');
        }
        const path = `/interactions/{interactionId}`
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Execute an interaction command assigned to an endpoint
    * @summary Execute an interaction command assigned to an endpoint
    * @param {string} endpointId endpointId
    * @param {string} interactionId InteractionId
    * @param {EndpointInteractionPostCommandRequest} body Interaction command request
    * @throws {RequiredError}
    */
    executeEndpointInteractionCommand(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling executeEndpointInteractionCommand.');
        }
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling executeEndpointInteractionCommand.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling executeEndpointInteractionCommand.');
        }
        const path = `/endpoints/{endpointId}/interactions/{interactionId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Execute a command against a skill group interaction
    * @summary Execute a command against a skill group interaction
    * @param {string} skillGroupId SkillGroupId
    * @param {string} interactionId InteractionId
    * @param {SkillGroupInteractionPostCommandRequest} body Source POST request object
    * @throws {RequiredError}
    */
    executeSkillGroupInteractionCommand(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling executeSkillGroupInteractionCommand.');
        }
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling executeSkillGroupInteractionCommand.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling executeSkillGroupInteractionCommand.');
        }
        const path = `/skillgroups/{skillGroupId}/interactions/{interactionId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId))
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all interactions for the given item.
    * @summary Get a interaction assigned to an endpoint
    * @param {string} endpointId endpointId
    * @param {string} interactionId InteractionId
    * @throws {RequiredError}
    */
    getEndpointInteraction(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointInteraction.');
        }
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling getEndpointInteraction.');
        }
        const path = `/endpoints/{endpointId}/interactions/{interactionId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all interactions assigned to this endpoint
    * @summary Get interactions assigned to this endpoint. Sometimes refered to as an inbox. These are active items currently being handled
    * @param {string} endpointId endpointId
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @throws {RequiredError}
    */
    getEndpointInteractions(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointInteractions.');
        }
        const path = `/endpoints/{endpointId}/interactions`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets an individual interaction in the system
    * @summary Get an interaction in the system by its id
    * @param {string} interactionId InteractionId
    * @throws {RequiredError}
    */
    getInteractionById(params) {
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling getInteractionById.');
        }
        const path = `/interactions/{interactionId}`
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets interactions.  Can be filtered with `$skip` and `$top` or items query parameters.
    * @summary Get interactions in the system. Interactions can by of any modality
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @throws {RequiredError}
    */
    getInteractions(params) {
        const path = `/interactions`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets interaction by id
    * @summary Get interaction by its id
    * @param {string} skillGroupId SkillGroupId
    * @param {string} interactionId InteractionId
    * @throws {RequiredError}
    */
    getSkillGroupInteraction(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling getSkillGroupInteraction.');
        }
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling getSkillGroupInteraction.');
        }
        const path = `/skillgroups/{skillGroupId}/interactions/{interactionId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId))
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all interacions for this skill group
    * @summary Get interactions in a skill group. These are the current queued interactions not routed
    * @param {string} skillGroupId SkillGroupId
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @throws {RequiredError}
    */
    getSkillGroupInteractions(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling getSkillGroupInteractions.');
        }
        const path = `/skillgroups/{skillGroupId}/interactions`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates a interaction with the given parameters.
    * @summary Update a interaction state
    * @param {string} skillGroupId SkillGroupId
    * @param {string} interactionId InteractionId
    * @param {InteractionPutRequest} body Source POST request object
    * @throws {RequiredError}
    */
    updateSkillGroupInteraction(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling updateSkillGroupInteraction.');
        }
        // verify required parameter 'interactionId' is not null or undefined
        if (params.interactionId === null || params.interactionId === undefined) {
            throw new utils_1.RequiredError('interactionId', 'Required parameter interactionId was null or undefined when calling updateSkillGroupInteraction.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSkillGroupInteraction.');
        }
        const path = `/skillgroups/{skillGroupId}/interactions/{interactionId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId))
            .replace(`{${'interactionId'}}`, String(params.interactionId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a reason with the given parameters. Reasons are the 'WHYs' which provide a way to categorize the type. E.g. Reasons for 'Away' type can be 'Lunch', 'break', 'Emergency' etc
    * @summary Create a reason
    * @param {ReasonPostRequest} body Reason POST request object
    * @throws {RequiredError}
    */
    createReason(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createReason.');
        }
        const path = `/reasons`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the reason for the provided ID.
    * @summary Delete a reason by its id
    * @param {string} reasonId ReasonId
    * @throws {RequiredError}
    */
    deleteReason(params) {
        // verify required parameter 'reasonId' is not null or undefined
        if (params.reasonId === null || params.reasonId === undefined) {
            throw new utils_1.RequiredError('reasonId', 'Required parameter reasonId was null or undefined when calling deleteReason.');
        }
        const path = `/reasons/{reasonId}`
            .replace(`{${'reasonId'}}`, String(params.reasonId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the reason for the provided ID.
    * @summary Get a reason by its id
    * @param {string} reasonId ReasonId
    * @throws {RequiredError}
    */
    getReason(params) {
        // verify required parameter 'reasonId' is not null or undefined
        if (params.reasonId === null || params.reasonId === undefined) {
            throw new utils_1.RequiredError('reasonId', 'Required parameter reasonId was null or undefined when calling getReason.');
        }
        const path = `/reasons/{reasonId}`
            .replace(`{${'reasonId'}}`, String(params.reasonId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets reasons.  Can be filtered with `$skip` and `$top` or items query parameters.
    * @summary Get reasons. Reasons are the WHYs.. i.e. for 'Away' type it can be 'lunch', 'break' etc.
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @param {string} [$Count] count the number of total records and return that along with the paged results. count property may differ from result set
    * @throws {RequiredError}
    */
    getReasons(params) {
        const path = `/reasons`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Count !== undefined) {
            query['$count'] = params.$Count;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the reason for the provided ID.
    * @summary Update a reason by its id
    * @param {string} reasonId ReasonId
    * @param {ReasonPutRequest} body Reason PUT request object
    * @throws {RequiredError}
    */
    updateReason(params) {
        // verify required parameter 'reasonId' is not null or undefined
        if (params.reasonId === null || params.reasonId === undefined) {
            throw new utils_1.RequiredError('reasonId', 'Required parameter reasonId was null or undefined when calling updateReason.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateReason.');
        }
        const path = `/reasons/{reasonId}`
            .replace(`{${'reasonId'}}`, String(params.reasonId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a skill with the given parameters.
    * @summary Create a skill
    * @param {SkillPostRequest} body Skill POST request object
    * @throws {RequiredError}
    */
    createSkill(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSkill.');
        }
        const path = `/skills`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the skill for the provided ID.
    * @summary Delete a skill by its id
    * @param {string} skillId SkillId
    * @throws {RequiredError}
    */
    deleteSkill(params) {
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling deleteSkill.');
        }
        const path = `/skills/{skillId}`
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the skill for the provided ID.
    * @summary Get a skill by its id
    * @param {string} skillId SkillId
    * @throws {RequiredError}
    */
    getSkill(params) {
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling getSkill.');
        }
        const path = `/skills/{skillId}`
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets skills.  Can be filtered with `$skip` and `$top` or items query parameters.
    * @summary Get skills. Skills are used to match up interactions with endpoints
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @param {string} [$Count] count the number of total records and return that along with the paged results. count property may differ from result set
    * @throws {RequiredError}
    */
    getSkills(params) {
        const path = `/skills`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Count !== undefined) {
            query['$count'] = params.$Count;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the endpoint for the provided ID.
    * @summary Update a skill by its id
    * @param {string} skillId SkillId
    * @param {SkillPutRequest} body Skill PUT request object
    * @throws {RequiredError}
    */
    updateSkill(params) {
        // verify required parameter 'skillId' is not null or undefined
        if (params.skillId === null || params.skillId === undefined) {
            throw new utils_1.RequiredError('skillId', 'Required parameter skillId was null or undefined when calling updateSkill.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSkill.');
        }
        const path = `/skills/{skillId}`
            .replace(`{${'skillId'}}`, String(params.skillId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a skill group with the given parameters.
    * @summary Create a skill group
    * @param {SkillGroupPostRequest} body Skill group POST request object
    * @throws {RequiredError}
    */
    createSkillGroup(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSkillGroup.');
        }
        const path = `/skillgroups`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the skill group for the provided ID.
    * @summary Delete a skill group by its id
    * @param {string} skillGroupId SkillGroupId
    * @throws {RequiredError}
    */
    deleteSkillGroup(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling deleteSkillGroup.');
        }
        const path = `/skillgroups/{skillGroupId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the skill group for the provided ID.
    * @summary Get a skill group by its id
    * @param {string} skillGroupId SkillGroupId
    * @throws {RequiredError}
    */
    getSkillGroup(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling getSkillGroup.');
        }
        const path = `/skillgroups/{skillGroupId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets current state of this skill group
    * @summary Get current state of a skill group
    * @param {string} skillGroupId SkillGroupId
    * @param {string} [$Expand] expands an attribute
    * @throws {RequiredError}
    */
    getSkillGroupState(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling getSkillGroupState.');
        }
        const path = `/skillgroups/{skillGroupId}/state`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets skill groups.  Can be filtered with `$skip` and `$top` or items query parameters.
    * @summary Get skill groups which are used to queue interactions.
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @param {string} [$Count] count the number of total records and return that along with the paged results. count property may differ from result set
    * @throws {RequiredError}
    */
    getSkillGroups(params) {
        const path = `/skillgroups`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Count !== undefined) {
            query['$count'] = params.$Count;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the skill group for the provided ID via patch
    * @summary Update a skill group by its Id via patch operation
    * @param {string} skillGroupId SkillGroupId
    * @param {PatchRequest} body Skill group PUT request object
    * @throws {RequiredError}
    */
    patchSkillGroup(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling patchSkillGroup.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchSkillGroup.');
        }
        const path = `/skillgroups/{skillGroupId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the skill group for the provided ID.
    * @summary Update a skill group by its Id
    * @param {string} skillGroupId SkillGroupId
    * @param {SkillGroupPutRequest} body Skill group PUT request object
    * @throws {RequiredError}
    */
    updateSkillGroup(params) {
        // verify required parameter 'skillGroupId' is not null or undefined
        if (params.skillGroupId === null || params.skillGroupId === undefined) {
            throw new utils_1.RequiredError('skillGroupId', 'Required parameter skillGroupId was null or undefined when calling updateSkillGroup.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSkillGroup.');
        }
        const path = `/skillgroups/{skillGroupId}`
            .replace(`{${'skillGroupId'}}`, String(params.skillGroupId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the service API
    * @summary Gets the main swagger document for this api
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the current status of this micro
    * @summary Get Status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a template with the given parameters.   Templates can be created for different purpose based on the 'Type' specified  E.g. It can be created for quick replies when handling interaction or for custom display extension.
    * @summary Create a template
    * @param {TemplatePostRequest} body Template POST request object
    * @throws {RequiredError}
    */
    createTemplate(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createTemplate.');
        }
        const path = `/templates`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the template for the provided ID.
    * @summary Delete a template by its id
    * @param {string} templateId templateId
    * @throws {RequiredError}
    */
    deleteTemplate(params) {
        // verify required parameter 'templateId' is not null or undefined
        if (params.templateId === null || params.templateId === undefined) {
            throw new utils_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling deleteTemplate.');
        }
        const path = `/templates/{templateId}`
            .replace(`{${'templateId'}}`, String(params.templateId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the template for the provided ID.
    * @summary Get a template by its id
    * @param {string} templateId templateId
    * @throws {RequiredError}
    */
    getTemplate(params) {
        // verify required parameter 'templateId' is not null or undefined
        if (params.templateId === null || params.templateId === undefined) {
            throw new utils_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling getTemplate.');
        }
        const path = `/templates/{templateId}`
            .replace(`{${'templateId'}}`, String(params.templateId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets templates.  Can be filtered with `$skip` and `$top` or items query parameters.
    * @summary Get templates. Templates are used for custom display extensions when handling interactions OR used for quick replies when handling interactions
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Token by which items are skipped
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Filter which subscriptions are returned  Example: ?$filter&#x3D;topic eq &#39;sample-topic&#39; and createdOn lt &#39;2018-03-14T15:09:26.535Z&#39;
    * @param {string} [items] Batch request of items by their keys (maximum 100) concatenated in comma separated format  Example: ?items&#x3D;key1,key2,key3
    * @param {string} [$Search] text based search
    * @param {string} [$Count] count the number of total records and return that along with the paged results. count property may differ from result set
    * @throws {RequiredError}
    */
    getTemplates(params) {
        const path = `/templates`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items !== undefined) {
            query['items'] = params.items;
        }
        if (params.$Search !== undefined) {
            query['$search'] = params.$Search;
        }
        if (params.$Count !== undefined) {
            query['$count'] = params.$Count;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the template for the provided ID via patch
    * @summary Update a template by its Id via patch operation
    * @param {string} templateId templateId
    * @param {PatchRequest} body Template PATCH request object
    * @throws {RequiredError}
    */
    patchTemplate(params) {
        // verify required parameter 'templateId' is not null or undefined
        if (params.templateId === null || params.templateId === undefined) {
            throw new utils_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling patchTemplate.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling patchTemplate.');
        }
        const path = `/templates/{templateId}`
            .replace(`{${'templateId'}}`, String(params.templateId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PATCH', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the template for the provided ID.
    * @summary Update a template by its id
    * @param {string} templateId templateId
    * @param {TemplatePutRequest} body Template PUT request object
    * @throws {RequiredError}
    */
    updateTemplate(params) {
        // verify required parameter 'templateId' is not null or undefined
        if (params.templateId === null || params.templateId === undefined) {
            throw new utils_1.RequiredError('templateId', 'Required parameter templateId was null or undefined when calling updateTemplate.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateTemplate.');
        }
        const path = `/templates/{templateId}`
            .replace(`{${'templateId'}}`, String(params.templateId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.RouterService = RouterService;
